document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".latest-brew");
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  let sectionVisible = false;
  let swiperInstance = null;

  function playCard(card) {
    if (!sectionVisible) return;
    const video = card.querySelector("video");
    if (video) {
      video.currentTime = 0;
      video.muted = false;
      video.play().catch(() => {});
    }
    card.classList.add("active");
  }

  function stopCard(card) {
    const video = card.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    card.classList.remove("active");
  }

  function stopAllCards() {
    document
      .querySelectorAll(".latest_brew_slider_inner_card")
      .forEach(stopCard);
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        sectionVisible = entry.isIntersecting;
        if (!sectionVisible) {
          stopAllCards();
        } else if (isMobile && swiperInstance) {
          const activeSlide =
            swiperInstance.slides[swiperInstance.activeIndex];
          if (activeSlide) playCard(activeSlide);
        }
      });
    },
    { threshold: 0.4 }
  );

  observer.observe(section);

  if (!isMobile) {
    document
      .querySelectorAll(".latest_brew_slider_inner_card")
      .forEach(card => {
        card.addEventListener("mouseenter", () => playCard(card));
        card.addEventListener("mouseleave", () => stopCard(card));
      });
  }

  if (typeof Swiper !== "undefined") {
    swiperInstance = new Swiper(".latest_brew_slider", {
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".latest_brew_arrow_right",
        prevEl: ".latest_brew_arrow_left",
      },
      breakpoints: {
        600: { slidesPerView: 2.3 },
        850: { slidesPerView: 3 },
        1025: { slidesPerView: 4.3 },
      },
      on: {
        slideChangeTransitionStart() {
          stopAllCards();
        },
        slideChangeTransitionEnd() {
          if (!sectionVisible) return;
          const activeSlide =
            swiperInstance.slides[swiperInstance.activeIndex];
          if (activeSlide) playCard(activeSlide);
        },
      },
    });
  }
});
